module.exports = __webpack_public_path__ + "img/jordskredaktsomhet.2491a693.jpg";